import React, { Component } from 'react';

import APIDocsBlock from '../APIDocsBlock';

export default class APIDocsGroupsBlock extends Component {
  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">Groups</div>
          <div className="text">
            Groups let you organize ideas within a company. They can be nested to build a hierarchy
            and are often used to scope ownership or product areas.
          </div>
          <div className="text">The Groups API allows you to list your groups.</div>
        </div>
        <div />
      </APIDocsBlock>
    );
  }
}
